import { Gantt } from '../../libs/dhtmlxgantt8/dhtmlxgantt';
import Config from './config';
import Grid from './grid';
import Chart from './chart/main';
import Workload from './workload';
import WorkloadLayout from './workload/layout';
import Events from './events';
import Extensions from './extensions';
import Controllers from './controllers';
import AutoSchedulePatches from './autoScheduling';
import ganttPreloader from './helpers/preloader';
import GanttAdapter from '$$store/adapters/gantt';
import Baselines from './baselines';
import GanttDataApi from './ganttDataApi';

// This file provide methods to init gantt instance for different app modes
export default {
  instance: null,

  async initGanttInstanceMultiView(multiviewId) {
    console.time('initGanttInstanceMultiView');

    this.destroyPreviousInstance();

    const instance = this.createInstance(multiviewId, true);

    this.instance = instance;

    const ganttIds = this.instance.ganttDataApi.getMultiviewItem(multiviewId).ganttIDs;
    const tasksData = this.instance.ganttDataApi.getTasksForMultiView(ganttIds);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    this.configureInstance(instance, ganttIds, projectConfig, true);
    this.renderInstance(instance, tasksData);

    // for(const ganttId of ganttIds) {
    //   await instance.ganttDataApi.correctDatesByProjectCalendar(ganttId);
    // }

    window.gantt2 = instance;

    console.timeEnd('initGanttInstanceMultiView');

    return instance;
  },

  initGanttInstance(ganttId) {
    console.time('initGanttInstance');

    this.destroyPreviousInstance(); // need destroy previous instance to avoid memory leaks

    const instance = this.createInstance(ganttId);

    this.instance = instance;

    const tasksData = this.instance.ganttDataApi.getTasksForGantt(ganttId);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    // different configuring strategies to for archived projects
    if (this.instance.config.isArchived) {
      this.configureInstanceArchived(instance, ganttId, projectConfig);
    } else {
      this.configureInstance(instance, ganttId, projectConfig);
    }

    this.renderInstance(instance, tasksData);
    // instance.ganttDataApi.correctDatesByProjectCalendar(ganttId);

    window.gantt2 = instance;

    console.timeEnd('initGanttInstance');

    return instance;
  },

  initGanttInstanceExport(ganttId) {
    console.time('initGanttInstanceExport');

    this.destroyPreviousInstance();

    const instance = this.createInstance(ganttId);

    this.instance = instance;

    const tasksData = this.instance.ganttDataApi.getTasksForGantt(ganttId);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    this.configureInstanceForExport(instance, ganttId, projectConfig);
    this.renderInstance(instance, tasksData);

    // window.gantt2 = instance;

    console.timeEnd('initGanttInstanceExport');

    return instance;
  },

  initGanttInstanceHistory(ganttId, ganttData) {
    console.time('initGanttInstanceHistory');

    this.destroyPreviousInstance();

    const instance = this.createInstance(ganttId, false, ganttData);

    this.instance = instance;

    const tasksData = this.instance.ganttDataApi.getTasksForGantt(ganttId);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    this.configureInstanceForHistory(instance, ganttId, projectConfig);
    this.renderInstance(instance, tasksData);

    // window.gantt2 = instance;

    console.timeEnd('initGanttInstanceHistory');

    return instance;
  },

  initGanttInstanceExportMultiview(multiviewId) {
    console.time('initGanttInstanceExportMultiview');

    this.destroyPreviousInstance();

    const instance = this.createInstance(multiviewId, true);

    this.instance = instance;

    const ganttIds = this.instance.ganttDataApi.getMultiviewItem(multiviewId).ganttIDs;
    const tasksData = this.instance.ganttDataApi.getTasksForMultiView(ganttIds);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    this.configureInstanceForExport(instance, ganttIds, projectConfig);
    this.renderInstance(instance, tasksData);

    // window.gantt2 = instance;

    console.timeEnd('initGanttInstanceExportMultiview');

    return instance;
  },

  initGanttInstanceWorkload(ganttIds) {
    console.time('initGanttInstanceWorkload');

    this.destroyPreviousInstance();

    const instance = Gantt.getGanttInstance();

    GanttDataApi.init(instance, null);

    this.instance = instance;
    window.gantt2 = instance;

    this.instance.config.isWorkload = true;

    const tasksData = this.instance.ganttDataApi.getTasksForMultiView(ganttIds);
    const projectConfig = this.instance.ganttDataApi.getActiveProjectConfig();

    this.configureInstance(instance, ganttIds, projectConfig, true);
    this.renderInstance(instance, tasksData, true);

    // AutoSchedulePatches.init(instance);
    // Controllers.init(instance);
    // Config.initBaseLayout(instance);
    // Extensions.init(instance);
    // // Chart.init(instance);
    // Events.init(instance);
    // GanttAdapter.init(instance);

    // this.renderInstance(instance, tasksData);

    // this.instance.$ui.getView('ganttChart').hide();
    // this.instance.$ui.getView('workload').resize();

    console.timeEnd('initGanttInstanceWorkload');
  },

  destroyPreviousInstance() {
    if (this.instance && !this.instance.$destroyed) {
      GanttAdapter.destruct();
      this.instance.destructor();
    }
  },

  createInstance(id, isMultiview = false, ganttData = null) {
    const instance = Gantt.getGanttInstance();

    GanttDataApi.init(instance, ganttData);

    instance.config[isMultiview ? 'multiview_id' : 'gantt_id'] = id;
    if (isMultiview) {
      instance.config.multiview = true;
    } else {
      const projectData = instance.ganttDataApi.getProjectItem(id);

      if (projectData.is_archived) instance.config.isArchived = true;
    }

    return instance;
  },

  configureInstance(instance, id, projectConfig, isMultiview = false) {
    // Order is important
    AutoSchedulePatches.init(instance);
    Controllers.init(instance); // Controller should be initialized before Config because we use them in Config
    Config.init(id, instance, projectConfig); // Set gantt.config, plugins, calendars and etc.
    Extensions.init(instance); // This module adds additional (sometimes override) functionality to gantt instance
    Grid.init(instance, projectConfig);
    Chart.init(instance);
    if (!isMultiview) {
      Baselines.init(instance);
    }
    GanttAdapter.init(instance); // GanttAdapter needs to sync gantt with vuex store
    Events.init(instance); // Handling system gantt events and custom events
  },

  configureInstanceForExport(instance, id, projectConfig) {
    // This method is lightweight copy of configureInstance method because we dont need all modules for export mode
    Controllers.initForExport(instance);
    Config.init(id, instance, projectConfig);
    Extensions.init(instance);
    Grid.initForExport(instance, projectConfig);
    Chart.init(instance);
    if (!instance.config.multiview) {
      Baselines.init(instance);
    }
    GanttAdapter.initForExport(instance);
    Events.initForExport(instance);
  },

  configureInstanceForHistory(instance, id, projectConfig) {
    // This method is lightweight copy of configureInstance method because we dont need all modules for history mode
    Controllers.initForExport(instance);
    Config.init(id, instance, projectConfig);
    Extensions.init(instance);
    Grid.initForExport(instance, projectConfig);
    Chart.init(instance);
    Events.initForExport(instance);
  },

  configureInstanceArchived(instance, id, projectConfig) {
    // This method is lightweight copy of configureInstance method because we dont need all modules for archived projects
    Controllers.initForArchived(instance);
    Config.init(id, instance, projectConfig);
    Extensions.init(instance);
    Grid.initForExport(instance, projectConfig);
    Chart.init(instance);
    Baselines.init(instance);
    GanttAdapter.initForArchived(instance);
    Events.initForArchived(instance);
  },

  resizeGantt() {
    WorkloadLayout.refreshHeight() || this.instance?.$layout?.resize?.();
  },

  renderInstance(instance, data, isWorkload = false) {
    ganttPreloader.show();
    setTimeout(() => {
      instance.init('new_gantt_here');
      instance.parse(data);
      Workload.init(instance);
      ganttPreloader.hide();
      !isWorkload && Events.initDomEvents(instance);
    }, 0);
  },
};
